<div class="price-summary">
    <div class="summary-header">
        <h5>
            {{ 'CONFIGURATION.PANEL.TITLE.PRICEOVERVIEW' | translate }}
        </h5>
        <vi-quest-hint
            *ngIf="!isSummaryPage && displayPriceAdvantage$ | async"
            [model]="{ text: 'CONFIGURATION.PANEL.PRICE_TOOLTIP' | translate, important: false }"
        >
        </vi-quest-hint>
    </div>
    <div class="summary-content">
        <div *ngIf="!isSummaryPage && showPartnerSelectionHint">
            <div class="content-warning">
                <div class="warning-icon">
                    <mat-icon>warning</mat-icon>
                </div>
                <div class="warning-content">
                    {{ 'CONFIGURATION.PANEL.HINT.PARTNER_SELECTION' | translate }}
                </div>
            </div>
        </div>
        <div class="content-price">
            <ng-container *ngIf="!isSummaryPage && !showPartnerSelectionHint">
                <ng-container *ngIf="displayPriceAdvantage$ | async">
                    <div class="price-item">
                        <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_GROSS' | translate }}:</div>
                        <div [attr.data-at-price-gross]="totalGross" class="item-value">
                            <ng-container *ngTemplateOutlet="price; context: { val: totalGross, currency: currency }" />
                        </div>
                    </div>
                    <div class="price-item price-discount">
                        <div class="item-label">
                            {{ 'CONFIGURATION.PANEL.LABEL.PACKAGE_PRICE_ADVANTAGE' | translate }}:
                        </div>
                        <div [attr.data-at-discount]="discount" class="item-value">
                            <ng-container *ngTemplateOutlet="price; context: { val: discount, currency: currency }" />
                        </div>
                    </div>
                    <div class="price-item price-total">
                        <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_PRICE' | translate }}:</div>
                        <div [attr.data-at-price-total]="totalPrice" class="item-value">
                            <ng-container *ngTemplateOutlet="price; context: { val: totalPrice, currency: currency }" />
                        </div>
                    </div>
                </ng-container>
                <div class="price-item price-total" *ngIf="(displayPriceAdvantage$ | async) === false">
                    <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_GROSS' | translate }}:</div>
                    <div [attr.data-at-price-total]="totalPrice" class="item-value">
                        <ng-container *ngTemplateOutlet="price; context: { val: totalGross, currency: currency }" />
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="isSummaryPage">
                <ng-container *ngIf="!isVitoclima">
                    <div class="price-item">
                        <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_GROSS' | translate }}:</div>
                        <div [attr.data-at-price-gross]="totalGross" class="item-value">
                            <ng-container *ngTemplateOutlet="price; context: { val: totalGross, currency: currency }" />
                        </div>
                    </div>
                    <div class="price-item price-discount" *ngIf="displayPriceAdvantage$ | async">
                        <div class="item-label">
                            {{ 'CONFIGURATION.PANEL.LABEL.PACKAGE_PRICE_ADVANTAGE' | translate }}:
                        </div>
                        <div [attr.data-at-discount]="discount" class="item-value discount">
                            <ng-container *ngTemplateOutlet="price; context: { val: discount, currency: currency }" />
                        </div>
                    </div>
                    <div class="price-item" *ngIf="displayPriceAdvantage$ | async">
                        <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_PRICE' | translate }}:</div>
                        <div [attr.data-at-price-total]="totalPrice" class="item-value">
                            <ng-container *ngTemplateOutlet="price; context: { val: totalPrice, currency: currency }" />
                        </div>
                    </div>
                </ng-container>
                <hr />
                <div *ngIf="(selectedCustomerService.isPlannerOrArchitect$ | async) === false" class="price-item">
                    <div class="item-label light-total">{{ 'CONFIGURATION.PANEL.LABEL.NET_PRICE' | translate }}:</div>
                    <div [attr.data-at-price-net]="netPrice" class="item-value light-total">
                        <ng-container *ngTemplateOutlet="price; context: { val: netPrice, currency: currency }" />
                    </div>
                </div>
                <div class="price-item">
                    <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.VAT' | translate }}:</div>
                    <div [attr.data-at-price-vat]="vat" class="item-value">
                        <ng-container *ngTemplateOutlet="price; context: { val: vat, currency: currency }" />
                    </div>
                </div>
                <hr />
                <div class="price-item price-total">
                    <div class="item-label">{{ 'CONFIGURATION.PANEL.LABEL.SUM_PRICE' | translate }}:</div>
                    <div [attr.data-at-price-sum]="sum" class="item-value">
                        <ng-container *ngTemplateOutlet="price; context: { val: sum, currency: currency }" />
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="content-voucher" *ngIf="isSummaryPage">
            <div
                class="voucher-code"
                *ngIf="
                    (hasConfiguration || isPvPlanner) &&
                    appService.getLocation().toUpperCase() === 'DE' &&
                    (selectedCustomerService.isPlannerOrArchitect$ | async) === false
                "
            >
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>{{
                            'CONFIGURATION.PANEL.CODE' | translate
                        }}</mat-expansion-panel-header>
                        <form [formGroup]="group">
                            <ng-container *ngIf="group.get('voucherCode') as control">
                                <div class="default-form-field">
                                    <mat-form-field
                                        [class.disabled-state]="
                                            validationInProgress || (dataService.isPriceSummaryLoading$ | async)?.value
                                        "
                                        appearance="outline"
                                    >
                                        <input
                                            matInput
                                            [formControl]="asFormControl(control)"
                                            [errorStateMatcher]="dirtyMatcher"
                                            placeholder="{{ 'SUMMARY.VOUCHER_CODE_INPUT' | translate }}"
                                        />
                                        <mat-hint class="hint-ok" *ngIf="control.valid && control.value">{{
                                            'OK' | translate
                                        }}</mat-hint>
                                        <mat-error *ngIf="control.hasError('validationError')">{{
                                            errorMessage
                                        }}</mat-error>
                                        <mat-error *ngIf="control.hasError('serverError')">{{
                                            'SUMMARY.VOUCHER_CODE_ERROR.SERVER_ERROR' | translate
                                        }}</mat-error>

                                        <mat-progress-bar
                                            mode="indeterminate"
                                            *ngIf="control.pending"
                                        ></mat-progress-bar>
                                    </mat-form-field>
                                </div>
                            </ng-container>
                        </form>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <div class="voucher-price-advantage" *ngIf="showDiscountButton()">
                <button
                    mat-stroked-button
                    color="primary"
                    (click)="openPartnerDiscountDialog()"
                    [disabled]="isVoucherSet()"
                >
                    {{ 'QUOTE_DISCOUNT_DIALOG.BUTTON' | translate }}
                </button>
            </div>
            <div
                class="voucher-no-price-advantage"
                *ngIf="noPriceAdvantageCheckboxAvailable && !isVoucherWithoutPriceAdvantage"
            >
                <mat-checkbox [checked]="quoteNoPriceAdvantage" (change)="setNoPriceAdvantage($event)">{{
                    'SUMMARY.NO_PRICE_ADVANTAGE.LABEL' | translate
                }}</mat-checkbox>
            </div>
        </div>
        <div class="content-info" *ngIf="isSummaryPage">
            <ng-container *ngIf="currentVoucher">
                <div class="info-item" *ngIf="isVoucherWithoutPriceAdvantage">
                    <div class="item-icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <div class="item-description">
                        {{ 'CONFIGURATION.PANEL.LABEL.VOUCHER.NO_PRICE_ADVANTAGE' | translate }}
                    </div>
                </div>
                <div class="info-item" *ngIf="voucherValue || extraBonus">
                    <div class="item-icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <div class="item-description">
                        {{
                            'PRICE_SUMMARY.INFO_TEXT.VOUCHER.' + voucherTypeKey
                                | translate : { voucherCode: currentVoucher.toLowerCase() }
                        }}
                        <span *ngIf="voucherValue">
                            {{
                                'PRICE_SUMMARY.INFO_TEXT.VOUCHER.VOUCHER_VALUE.' + voucherTypeKey
                                    | translate : { voucherValue: voucherValue | currency : currency : 'symbol-narrow' }
                            }}
                        </span>
                        <span *ngIf="extraBonus">{{
                            'PRICE_SUMMARY.INFO_TEXT.VOUCHER.EXTRA_BONUS'
                                | translate : { extraBonus: extraBonus | currency : currency : 'symbol-narrow' }
                        }}</span>
                    </div>
                </div>
            </ng-container>
            <div class="info-item info-warning" *ngIf="displayPriceAdvantage$ | async">
                <div class="item-icon">
                    <mat-icon>warning</mat-icon>
                </div>
                <div class="item-description">
                    {{ 'PRICE_SUMMARY.INFO_TEXT.PRICE_ADVANTAGE' | translate }}
                </div>
            </div>
        </div>
    </div>
    <div class="summary-progress">
        <mat-progress-bar
            mode="indeterminate"
            *ngIf="(dataService.isPriceSummaryLoading$ | async)?.value"
        ></mat-progress-bar>
    </div>
</div>
<ng-template #price let-val="val" let-currency="currency">
    @if(hasErrors | async) {
    {{ 'CONFIGURATION.PANEL.LABEL.NOT_AVAILABLE' | translate }}
    } @else {
    {{ val | currency : currency : 'symbol-narrow' }}
    }
</ng-template>
